<div class="v-card card modal-card">
  <div class="card-header modal-card-header fs-16 font-weight-600">
    {{ 'MODALS.WORKFLOW-SHARING.TITLE' | translate }}
  </div>

  <div class="card-body modal-card-body p-0">
    <!-- Loading State -->
    @if (isLoading) {
      <div class="px-4 py-4 text-center">
        <div class="spinner-border spinner-border-sm text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    }

    <!-- Not a Parent Account -->
    @if (!isLoading && !isParentAccount) {
      <div class="px-4 py-4">
        <div class="alert alert-info mb-0">
          <i class="fas fa-info-circle mr-2"></i>
          {{ 'MODALS.WORKFLOW-SHARING.NOT_PARENT_ACCOUNT' | translate }}
        </div>
      </div>
    }

    <!-- Share with Child Accounts Section -->
    @if (!isLoading && isParentAccount) {
      <div class="px-4 py-4">
        <p class="text-muted fs-14 mb-3">
          {{ 'MODALS.WORKFLOW-SHARING.DESCRIPTION' | translate }}
        </p>
        <div class="card">
          <div class="card-body">
            @if (childAccounts.length === 0) {
              <p class="text-muted fs-12 mb-3">
                {{ 'MODALS.WORKFLOW-SHARING.NO_CHILDREN' | translate }}
              </p>
            }
            @for (child of childAccounts; track child) {
              <div class="form-check mb-2">
                <input type="checkbox" class="form-check-input"
                  [id]="'share-' + child.id"
                  [(ngModel)]="sharingSelection[child.id]">
                <label class="form-check-label fs-14" [for]="'share-' + child.id">
                  {{ child.name }}
                </label>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>

  <div class="card-footer modal-card-footer">
    <button class="v-btn btn btn-sm btn-outline-secondary" (click)="close()">
      {{ 'MODALS.WORKFLOW-SHARING.CLOSE' | translate }}
    </button>
    @if (isParentAccount && childAccounts.length > 0) {
      <button class="v-btn btn btn-sm btn-primary"
        (click)="saveSharing()"
        >
        {{ 'MODALS.WORKFLOW-SHARING.SAVE' | translate }}
      </button>
    }
  </div>
</div>
